import "../SignIn/SignIn.css";
import { Col, Row, Button } from "react-bootstrap";
// import { FaFacebook } from "react-icons/fa";
import Form from "react-bootstrap/Form";
import {
  FirstNameCheck,
  LastNameCheck,
  EmailCheck,
  MobileNumberCheck,
  AddressCheck,
  ZipCodeCheck,
} from "../../ConditionChecks/ConditionChecks";
import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import { GetCity, GetCountry, GetState } from "../../Utils/Api/SignUP";
import { useState } from "react";
// import the progress bar
// import the stylesheet
import "react-step-progress/dist/index.css";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCostHistory } from "../../redux/costHistorySlice";
import AutoCompleteInput from "../../Components/AutoCompleteInput/AutoCompleteInput";
import { Link, useNavigate } from "react-router-dom";
import { MdArrowBack } from "react-icons/md";
import { EmailCheckApi } from "../../Utils/Api/EmailCheckApi";
import { MobileValidateApi } from "../../Utils/Api/MobileValidateApi";

const step1Content = <h1>Step 1 Content</h1>;
const step2Content = <h1>Step 2 Content</h1>;
const step3Content = <h1>Step 3 Content</h1>;

// setup step validators, will be called before proceeding to the next step
function step2Validator() {
  // return a boolean
}

function step3Validator() {
  // return a boolean
}

function onFormSubmit() {
  // handle the submit logic here
  // This function will be executed at the last step
  // when the submit button (next button in the previous steps) is pressed
}

const GeneralInfo = ({ NextStep, GrData, city_id }) => {
  const dispatch = useDispatch();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [addressOne, setAddressOne] = useState("");
  const [addressTwo, setAddressTwo] = useState("");
  const [selectCountry, setSelectCountry] = useState("");
  const [selectState, setSelectState] = useState("");
  const [selectCity, setSelectCity] = useState("");
  const [zipcode, setZipCode] = useState("");

  const [validationfirstName, setValidationFirstName] = useState("");
  const [validationlastName, setValidationLastName] = useState("");
  const [validationemail, setValidationEmail] = useState("");
  const [validationmobileNumber, setValidationMobileNumber] = useState("");
  const [err_DisplayAddressOne, setErr_DisplayAddressOne] = useState("");
  const [err_DisplayAddressTwo, setErr_DisplayAddressTwo] = useState("");
  const [err_DisplaySelectCountry, setErr_DisplaySelectCountry] = useState("");
  const [err_DisplaySelectState, setErr_DisplaySelectState] = useState("");
  const [err_DisplaySelectCity, setErr_DisplaySelectCity] = useState("");
  const [err_DisplayZipcode, setErr_DisplayZipcode] = useState("");

  const [emailCheckflag, setEmailCheckFlag] = useState(false);
  const [MobileCheckflag, setMobileCheckFlag] = useState(false);

  const [countryList, setCountryList] = useState([
    { country_id: "", state_name: "" },
  ]);
  const [stateList, setStateList] = useState([
    {
      mms_city_id: "",
      city_name: "",
    },
  ]);
  const [cityList, setCityList] = useState([]);

  const navigate = useNavigate();

  const onFirstName = (event) => {
    setFirstName(event.target.value);
    setValidationFirstName("");
  };

  const onLastName = (event) => {
    setLastName(event.target.value);
    setValidationLastName("");
  };

  const onEmail = (event) => {
    let Email = event.target.value;
    setEmail(event.target.value);
    setValidationEmail("");
    EmailValidate(Email);
  };

  const formatPhoneNumber = (value) => {
    let digits = value.replace(/\D/g, "");
    digits = digits.substring(0, 10);
    let formatted = digits;
    if (digits.length > 3) {
      formatted = digits.substring(0, 3) + "-" + digits.substring(3);
    }
    if (digits.length > 6) {
      formatted = formatted.substring(0, 7) + "-" + formatted.substring(7);
    }

    return formatted;
  };
  const validatePhoneNumber = (value) => {
    let digits = value.replace(/\D/g, "");
    return digits.length === 10;
  };

  const onMobileNumber = (event) => {
    let formattedValue = formatPhoneNumber(event.target.value);
    setMobileNumber(formattedValue);
    if (!validatePhoneNumber(formattedValue)) {
      setValidationMobileNumber("Please enter a valid mobile number!");
    } else {
      setValidationMobileNumber("");
      const MobileFormated = formattedValue.replace(/-/g, "");
      MobileValidate(MobileFormated);
    }
  };

  const onAddressOne = (event) => {
    setAddressOne(event.target.value);
    setErr_DisplayAddressOne("");
  };

  const onAddressTwo = (event) => {
    setAddressTwo(event.target.value);
    setErr_DisplayAddressTwo("");
  };

  const onSelectCountry = (event) => {
    setSelectCountry(event.target.value);
    setErr_DisplaySelectCountry("");
  };

  const onSelectState = (event) => {
    setSelectState(event.target.value);
    setErr_DisplaySelectState("");
  };

  const onSelectCity = (event) => {
    setSelectCity(event.target.value);
    setErr_DisplaySelectCity("");
  };

  const onZipCode = (event) => {
    setZipCode(event.target.value);
    setErr_DisplayZipcode("");
  };

  const OnTransactionFeeKeyDown = (e) => {
    if (e.key === "-" || e.key === "+") {
      e.preventDefault();
    }
  };

  const SubmitHandler = (event) => {
    event.preventDefault();

    const FirstNameValidation = FirstNameCheck(firstName);
    const LastNameValidation = LastNameCheck(lastName);
    const EmailValidation = EmailCheck(email);
    // const MobileNumberValidation = MobileNumberCheck(mobileNumber);
    const AddressOneValidation = AddressCheck(addressOne);
    const AddressTwoValidation = AddressCheck(addressTwo);
    const ZipCodeValidation = ZipCodeCheck(zipcode);
    let CountryStateCityValidation = true;

    if (FirstNameValidation.input === "empty") {
      setValidationFirstName(FirstNameValidation.err_display);
    } else if (FirstNameValidation.input === "invalid") {
      setValidationFirstName(FirstNameValidation.err_display);
    }

    if (LastNameValidation.input === "empty") {
      setValidationLastName(LastNameValidation.err_display);
    } else if (LastNameValidation.input === "invalid") {
      setValidationLastName("Enter the valid Last Name!");
    }

    if (EmailValidation.input === "empty") {
      setValidationEmail(EmailValidation.err_display);
    } else if (EmailValidation.input === "invalid") {
      setValidationEmail(EmailValidation.err_display);
    }

    // if (MobileNumberValidation.input === "empty") {
    //   setValidationMobileNumber(MobileNumberValidation.err_display);
    // } else if (MobileNumberValidation.input === "invalid") {
    //   setValidationMobileNumber(MobileNumberValidation.err_display);
    // } else if (MobileNumberValidation.input === "less") {
    //   setValidationMobileNumber(MobileNumberValidation.err_display);
    // }

    if (mobileNumber.length === 0) {
      setValidationMobileNumber("Please enter mobile number!");
    }

    if (AddressOneValidation.input === "empty") {
      setErr_DisplayAddressOne(AddressOneValidation.err_display);
    } else if (AddressOneValidation.input === "maxCharacters") {
      setErr_DisplayAddressOne(AddressOneValidation.err_display);
    }

    // if (AddressTwoValidation.input === "empty") {
    //   setErr_DisplayAddressTwo(AddressTwoValidation.err_display);
    // } else if (AddressTwoValidation.input === "maxCharacters") {
    //   setErr_DisplayAddressTwo(AddressTwoValidation.err_display);
    // }

    if (!selectCountry) {
      setErr_DisplaySelectCountry("Please select the Country!");
      CountryStateCityValidation = false;
    }
    if (!selectState) {
      setErr_DisplaySelectState("Please select the State!");
      CountryStateCityValidation = false;
    }

    if (!selectCity) {
      setErr_DisplaySelectCity("Please enter the City!");
      CountryStateCityValidation = false;
    }
    console.log(ZipCodeValidation, "ZipCodeValidation");
    if (ZipCodeValidation.input === "empty") {
      setErr_DisplayZipcode(ZipCodeValidation.err_display);
    } else if (ZipCodeValidation.input === "invalid") {
      setErr_DisplayZipcode(ZipCodeValidation.err_display);
    } else if (ZipCodeValidation.input === "Characters") {
      setErr_DisplayZipcode(ZipCodeValidation.err_display);
    }

    const MobileFormated = mobileNumber.replace(/-/g, "");

    if (
      FirstNameValidation.validition &&
      LastNameValidation.validition &&
      EmailValidation.validition &&
      AddressOneValidation.validition &&
      ZipCodeValidation.validition &&
      emailCheckflag === false &&
      MobileCheckflag === false &&
      validationmobileNumber === "" &&
      CountryStateCityValidation === true
    ) {
      let SignUpDetails = {
        eu_first_name: firstName,
        eu_last_name: lastName,
        eu_email: email,
        eu_contact_number: parseInt(MobileFormated),
        bu_address_one: addressOne,
        bu_address_two: addressTwo,
        bu_zipCode: zipcode,
        bu_country: parseInt(selectCountry),
        bu_state: parseInt(selectState),
        bu_city: selectCity,
        submitflag: true,
      };

      const NextStepFlag = 1;
      city_id(parseInt(selectCity));
      NextStep(NextStepFlag);
      dispatch(getCostHistory(NextStep));
      GrData(SignUpDetails);

      // setFirstName("");
      // setLastName("");
      // setEmail("");
      // setMobileNumber("");
      // setAddressOne("");
      // setAddressTwo("");
      // setSelectCountry("");
      // setSelectState("");
      // setSelectCity("");
      // setZipCode("");
    }
  };

  const GeneralInfoAPIHandler = async () => {
    const getCountry = await GetCountry();

    setCountryList(getCountry.data);
  };

  const GetStateApiHandler = async () => {
    const data = {
      country_id: parseInt(selectCountry),
    };
    const getState = await GetState(data, () => {
      navigate("/");
    });
    if (selectCountry.length > 0) {
      setStateList(getState.data);
    } else {
      setStateList([]);
    }
  };

  const GetCityApiHandler = async () => {
    const data = {
      state_id: parseInt(selectState),
    };
    const getCity = await GetCity(data, () => {
      navigate("/");
    });
    if (selectState.length > 0) {
      setCityList(getCity.data);
    } else {
      setCityList([]);
    }
  };

  const EmailValidate = async (val) => {
    const data = {
      email: val,
    };
    const EmailCheckRes = await EmailCheckApi(data, () => {
      navigate("/");
    });
    if (EmailCheckRes.success === false) {
      setValidationEmail(EmailCheckRes.message);
      setEmailCheckFlag(true);
    } else {
      setValidationEmail(EmailCheckRes.message);
      setEmailCheckFlag(false);
    }
  };

  const MobileValidate = async (val) => {
    const data = {
      bu_contact_number: parseInt(val),
    };
    const MobileCheckRes = await MobileValidateApi(data, () => {
      navigate("/");
    });
    if (MobileCheckRes.success === false) {
      setValidationMobileNumber(MobileCheckRes.message);
      setMobileCheckFlag(true);
    } else {
      setValidationMobileNumber(MobileCheckRes.message);
      setMobileCheckFlag(false);
    }
  };

  useEffect(() => {
    GeneralInfoAPIHandler();
  }, []);

  useEffect(() => {
    GetStateApiHandler();
  }, [selectCountry]);

  useEffect(() => {
    GetCityApiHandler();
  }, [selectState]);

  // console.log(selectCountry)

  return (
    <>
      <div className="main">
        <Row className="justify-content-md-center py-3">
          <Col md="12" className="">
            <Row>
              <div className="signemail pt-3">
                <Form onSubmit={SubmitHandler} className="formmain signin-row">
                  <Row>
                    <Col md="6">
                      <Form.Group className="">
                        <Form.Label className="form-label-custom">
                          First Name <span className="star-required">*</span>
                        </Form.Label>
                        <Form.Control
                          type="input"
                          placeholder="Enter First Name"
                          className="custom-formcontrol"
                          onChange={onFirstName}
                          value={firstName}
                          maxLength={50}
                          autoComplete="off"
                        />
                        <ErrorLabel ErrorDisplay={validationfirstName} />
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group className="">
                        <Form.Label className="form-label-custom">
                          Last Name <span className="star-required">*</span>
                        </Form.Label>
                        <Form.Control
                          type="input"
                          placeholder="Enter Last Name"
                          className="custom-formcontrol"
                          onChange={onLastName}
                          value={lastName}
                          maxLength={50}
                          autoComplete="off"
                        />
                        <ErrorLabel ErrorDisplay={validationlastName} />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group className="">
                        <Form.Label className="form-label-custom">
                          <p
                            className="info-text-space"
                            style={{ visibility: "hidden" }}
                          >
                            &#40;Numbers only. No dash (-) or dot(.) between
                            numbers&#41;
                          </p>
                          Contact Email Address{" "}
                          <span className="star-required">*</span>
                        </Form.Label>
                        <Form.Control
                          // type="email"
                          placeholder="Enter Email Address"
                          className="custom-formcontrol"
                          onChange={onEmail}
                          value={email}
                          maxLength={70}
                          autoComplete="off"
                        />
                        <ErrorLabel ErrorDisplay={validationemail} />
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group
                        className="mobile_Number"
                        controlId="formBasicEmail"
                      >
                        <Form.Label className="form-label-custom">
                          Mobile Number <span className="star-required">*</span>
                          <p className="info-text-space">
                            &#40;Numbers only. No dash (-) or dot(.) between
                            numbers&#41;
                          </p>
                        </Form.Label>
                        <div className="sign_up_Mobile">
                          <Form.Control
                            className="custom-formcontrol"
                            value="+1"
                            disabled
                          />
                          <Form.Control
                            type="text"
                            placeholder="Enter Mobile Number"
                            className="custom-formcontrol flex-1"
                            onChange={onMobileNumber}
                            // onKeyDown={OnTransactionFeeKeyDown}
                            value={mobileNumber}
                            autoComplete="off"
                          />
                        </div>
                        <ErrorLabel ErrorDisplay={validationmobileNumber} />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Form.Group className="">
                        <Form.Label className="form-label-custom">
                          Business Street Address Line 1{" "}
                          <span className="star-required">*</span>
                        </Form.Label>
                        <Form.Control
                          type="input"
                          placeholder="Enter Business Address 1"
                          className="custom-formcontrol"
                          onChange={onAddressOne}
                          value={addressOne}
                          maxLength={100}
                          autoComplete="off"
                        />
                        <ErrorLabel ErrorDisplay={err_DisplayAddressOne} />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Form.Group className="">
                        <Form.Label className="form-label-custom">
                          Business Street Address Line 2{" "}
                        </Form.Label>
                        <Form.Control
                          type="input"
                          placeholder="Enter Business Address 2"
                          className="custom-formcontrol"
                          onChange={onAddressTwo}
                          value={addressTwo}
                          maxLength={100}
                          autoComplete="off"
                        />
                        <ErrorLabel ErrorDisplay={err_DisplayAddressTwo} />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group
                        className="custom-form-select"
                        controlId="formBasicEmail"
                      >
                        <Form.Label className="form-label-custom">
                          Country <span className="star-required">*</span>
                        </Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          onChange={onSelectCountry}
                          value={selectCountry}
                        >
                          <option>Select Country</option>
                          {countryList?.map((data) => {
                            return (
                              <option
                                value={data.country_id}
                                key={data.country_id}
                              >
                                {data.country_name}
                              </option>
                            );
                          })}
                        </Form.Select>
                        <ErrorLabel ErrorDisplay={err_DisplaySelectCountry} />
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group
                        className="custom-form-select"
                        controlId="formBasicEmail"
                      >
                        <Form.Label className="form-label-custom">
                          State/Province{" "}
                          <span className="star-required">*</span>
                        </Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          onChange={onSelectState}
                          value={selectState}
                        >
                          <option>Tap to select</option>
                          {stateList.length > 0 ? (
                            stateList.map((data) => {
                              return (
                                <option
                                  value={data.state_id}
                                  key={data.state_id}
                                >
                                  {data.state_name}
                                </option>
                              );
                            })
                          ) : (
                            <></>
                          )}
                        </Form.Select>
                        <ErrorLabel ErrorDisplay={err_DisplaySelectState} />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <AutoCompleteInput
                      CityList={cityList}
                      EditFlag={true}
                      EditCity={selectCity}
                      ApiCity={""}
                      onCityFuc={onSelectCity}
                      ErrDisplay={err_DisplaySelectCity}
                      NameFlag={"myBrowser"}
                      Md={"6"}
                      className="cityInput"
                    />

                    {/* <Col md="6">
                      <Form.Group
                        className="custom-form-select"
                        controlId="formBasicEmail"
                      >
                        <Form.Label className="form-label-custom">
                          City <span className="star-required">*</span>
                        </Form.Label>
                        <Form.Select
                          aria-label="Default select example"
                          onChange={onSelectCity}
                          value={selectCity}
                        >
                          <option>Tap to select</option>
                          {cityList.length > 0 ? (
                            cityList.map((data) => {
                              return (
                                <option value={data.mms_city_id}>
                                  {data.city_name}
                                </option>
                              );
                            })
                          ) : (
                            <></>
                          )}
                        </Form.Select>
                        <ErrorLabel ErrorDisplay={err_DisplaySelectCity} />
                      </Form.Group>
                    </Col> */}

                    <Col md="6">
                      <Form.Group
                        className="custom-form-select"
                        controlId="formBasicEmail"
                      >
                        <Form.Label className="form-label-custom">
                          Zipcode <span className="star-required">*</span>
                        </Form.Label>
                        <Form.Control
                          type="input"
                          placeholder="Enter Zipcode"
                          className="custom-formcontrol"
                          onChange={onZipCode}
                          value={zipcode}
                          maxLength={11}
                          autoComplete="off"
                        />
                        <ErrorLabel ErrorDisplay={err_DisplayZipcode} />
                      </Form.Group>
                    </Col>
                  </Row>
                  <div className="text-center small-btns d-flex back_Button_Div">
                    {/* <Link>
                          <p className="view">Previous</p>
                        </Link> */}
                    <Button
                      variant="primary"
                      type="submit"
                      className="green-btn mt-3 sign_up_next"
                    >
                      Next
                    </Button>
                    <Link to="/" className="backSignup">
                      <MdArrowBack />
                      Back
                    </Link>
                  </div>
                  {/* <button type="submit"></button> */}
                </Form>
              </div>
            </Row>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default GeneralInfo;
